import { Component, Input, OnInit } from '@angular/core';
import { AvailabilityStatus } from './../../../../../../../../_shared/enums/treatment/availabilityStatus.enum';

@Component({
    selector: 'trt-wid-m-term-badge',
    templateUrl: './trt-wid-m-term-badge.component.html',
    styles: [],
})
export class TrtWidMTermBadgeComponent implements OnInit {
    @Input()
    public status: AvailabilityStatus;

    public availabilityStatus: typeof AvailabilityStatus = AvailabilityStatus;

    // TODO Ignored with eslint-interactive on 2023-11-10
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    constructor() {}

    // TODO Ignored with eslint-interactive on 2023-11-10
    // eslint-disable-next-line @angular-eslint/no-empty-lifecycle-method, @typescript-eslint/no-empty-function
    ngOnInit() {}
}
